<template>
  <van-nav-bar
    v-if="!$route.meta.hideNavBar"
    :title="$route.meta.title ? $t($route.meta.title) : ''"
    :left-arrow="!$route.meta.hideBackIcon"
    @click-left="goBack"
    class="van-nav-bar"
  />
</template>

<script>
export default {
  name: "BNavbar",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    goBack() {
      if (this.$route.name === "APPLICATION-RESULT") {
        this.$router.push("/home");
        return;
      }
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.van-nav-bar__title {
  font-size: 18px !important;
  font-weight: 600 !important;
}
</style>
